<div class="container-fluid row_banner">
  <app-header></app-header>
  <div class="container my-5">
    <div class="row justify-content-center">
      <div class="col-sm-10 py-5 faq-container">
        <h2 class="text-center mb-4 headFont">
          Pick a plan that’s right for you
        </h2>
        <p class="text-center mb-5 headFontP">
          Check which plan is best for You. We care about your convenience in
          using the application, so <br />
          you can upgrade your plan up or down at any time.
        </p>

        <!-- Pricing Update Section -->

        <div class="row g-4 flex-pricing pb-2 pt-2">
          <div class="col-lg-4">
            <div class="card card-pricing">
              <h3
                class="ms-2"
                style="font-size: 30px; font-weight: 700"
                *ngIf="!isUserLoggedin"
              >
                FREE
              </h3>
              <h3
                class="ms-2"
                style="font-size: 30px; font-weight: 700"
                *ngIf="
                  isUserLoggedin &&
                  (!premium_user_done ||
                    premium_user_done == null ||
                    premium_user_done)
                "
              >
                Upgrade Time!
              </h3>
              <p class="text-center" *ngIf="isUserLoggedin">
                You're currently using our <b>FREE</b> plan.
              </p>
              <p class="text-center" *ngIf="!isUserLoggedin">
                Start with the Free Plan and upgrade anytime as your needs grow!
              </p>
              <p
                class="text-center"
                *ngIf="
                  isUserLoggedin &&
                  (!premium_user_done ||
                    premium_user_done == null ||
                    premium_user_done)
                "
              >
                Upgrade to access Premium features!
              </p>
              <br />

              <h3
                class="ms-2 mb-2"
                style="font-size: 46px; font-weight: 700"
                *ngIf="!isUserLoggedin"
              >
                $0<span
                  style="font-size: 16px; font-weight: 600px; color: #c4c8cb"
                  *ngIf="!isUserLoggedin"
                  >/Week</span
                >
              </h3>
              <hr class="mb-5" />

              <ul class="list-unstyled">
                <li *ngFor="let feature of pricingFeatures">
                  <app-icons-free-tools name="tickPricingIcon" class="me-2" />
                  {{ feature }}
                </li>
              </ul>

              <div class="card-btnn">
                <!-- (click)="navigateTosignup()" -->
                <button
                  class="btn acount"
                  *ngIf="!isUserLoggedin"
                  [routerLink]="['/signup']"
                >
                  Create Account
                </button>
                <!-- (click)="checkUserIdAndRoutesignup()" -->
                <!-- <button class="btn acount" *ngIf="isUserLoggedin && (!premium_user_done || premium_user_done == null)" (click)="checkUserIdAndRouteplans()">Select any plan</button> -->
              </div>
            </div>
          </div>

          <div class="col-lg-8">
            <div class="planing" style="background-color: white">
              <div class="row pricing-plan g-4">
                <div class="col-md-4">
                  <div
                    class="plan-option"
                    id="Monthly"
                    [ngClass]="{
                      'plan-optionSelect': selectedPlan === 'Monthly',
                      hovered: hoveredPlan === 'Monthly'
                    }"
                    (mouseenter)="onHover('Monthly')"
                    (mouseleave)="onLeave()"
                    (click)="onSelect('Monthly')"
                  >
                    <div class="mb-4 pricingpercentText">
                      <div
                        class="plan-optionText"
                        [ngClass]="{
                          'plan-optionSelectText': selectedPlan === 'Monthly'
                        }"
                      >
                        Monthly
                      </div>
                      <div
                        class="div3 pricingpercent"
                        style="float: right"
                        [ngClass]="{
                          pricingpercentSelect: selectedPlan === 'Monthly'
                        }"
                      >
                        50% OFF
                      </div>
                    </div>
                    <h3>
                      <strong
                        [ngClass]="{
                          'plan-optionSelectText': selectedPlan === 'Monthly'
                        }"
                        >$7.50</strong
                      >
                      <del
                        class="ms-2"
                        style="font-size: 17px; font-weight: 300"
                        >$15</del
                      >
                    </h3>
                    <a>
                      <button
                        class="btn-ouline mt-4"
                        [ngClass]="{
                          'btn-ouline-green': selectedPlan === 'Monthly'
                        }"
                        *ngIf="
                          (!this.isUserLoggedin || this.isUserLoggedin) &&
                          !premium_user_done
                        "
                        (click)="
                          checkUserIdAndRoute(
                            'Monthly',
                            '$7.50',
                            'price_1Q6AFpIcvPV98dDokZi78LKx'
                          )
                        "
                      >
                        Select Plan
                      </button>
                    </a>
                  </div>
                </div>
                <div class="col-md-4">
                  <div
                    class="plan-option plan-optionSelect"
                    id="Quarterly"
                    [ngClass]="{
                      'plan-optionSelect': selectedPlan === 'Quarterly',
                      hovered: hoveredPlan === 'Quarterly'
                    }"
                    (mouseenter)="onHover('Quarterly')"
                    (mouseleave)="onLeave()"
                    (click)="onSelect('Quarterly')"
                  >
                    <div class="mb-4 pricingpercentText">
                      <div
                        class="plan-optionText plan-optionText"
                        [ngClass]="{
                          'plan-optionSelectText': selectedPlan === 'Quarterly'
                        }"
                      >
                        Quarterly
                      </div>
                      <div
                        class="div3 pricingpercent"
                        [ngClass]="{
                          pricingpercentSelect: selectedPlan === 'Quarterly'
                        }"
                        style="float: right"
                      >
                        50% OFF
                      </div>
                    </div>
                    <h3>
                      <strong
                        class="plan-optionSelectText"
                        [ngClass]="{
                          'plan-optionSelectText': selectedPlan === 'Quarterly'
                        }"
                        >$15</strong
                      >
                      <del
                        class="ms-2"
                        style="font-size: 17px; font-weight: 300"
                        >$30</del
                      >
                    </h3>
                    <button
                      class="btn-ouline mt-4"
                      [ngClass]="{
                        'btn-ouline-green': selectedPlan === 'Quarterly'
                      }"
                      *ngIf="
                        (!this.isUserLoggedin || this.isUserLoggedin) &&
                        !premium_user_done
                      "
                      (click)="
                        checkUserIdAndRoute(
                          'Quarterly',
                          '$15',
                          'price_1Q6AeuIcvPV98dDoc2fUYvhM'
                        )
                      "
                    >
                      Select Plan
                    </button>
                  </div>
                </div>
                <div class="col-md-4">
                  <div
                    class="plan-option"
                    id="Yearly"
                    [ngClass]="{
                      'plan-optionSelect': selectedPlan === 'Yearly',
                      hovered: hoveredPlan === 'Yearly'
                    }"
                    (mouseenter)="onHover('Yearly')"
                    (mouseleave)="onLeave()"
                    (click)="onSelect('Yearly')"
                  >
                    <div class="mb-4 pricingpercentText">
                      <div
                        class="plan-optionText"
                        [ngClass]="{
                          'plan-optionSelectText': selectedPlan === 'Yearly'
                        }"
                      >
                        Yearly
                      </div>
                      <div
                        class="div3 pricingpercent"
                        [ngClass]="{
                          pricingpercentSelect: selectedPlan === 'Yearly'
                        }"
                        style="float: right"
                      >
                        50% OFF
                      </div>
                    </div>
                    <h3>
                      <strong
                        [ngClass]="{
                          'plan-optionSelectText': selectedPlan === 'Yearly'
                        }"
                        >$40</strong
                      >
                      <del
                        class="ms-2"
                        style="font-size: 17px; font-weight: 300"
                        >$80</del
                      >
                    </h3>
                    <button
                      class="btn-ouline mt-4"
                      [ngClass]="{
                        'btn-ouline-green': selectedPlan === 'Yearly'
                      }"
                      *ngIf="
                        (!this.isUserLoggedin || this.isUserLoggedin) &&
                        !premium_user_done
                      "
                      (click)="
                        checkUserIdAndRoute(
                          'annual',
                          '$40',
                          'price_1Q6Ag7IcvPV98dDoHGszhDz0'
                        )
                      "
                    >
                      Select Plan
                    </button>
                  </div>
                </div>
              </div>

              <div class="mt-4">
                <h4 class="mb-5 upgradePhone">
                  <app-icons-free-tools name="starPricingIcon" class="me-2" />
                  Upgrade to Access
                </h4>
                <div class="flex-container">
                  <ul class="list-unstyled ul-list">
                    <li *ngFor="let feature of premiumFeatures">
                      <app-icons-free-tools
                        name="tickPricingIcon"
                        class="me-2"
                      />
                      {{ feature }}
                    </li>
                  </ul>

                  <ul class="list-unstyled">
                    <li *ngFor="let feature of advancedFeatures">
                      <app-icons-free-tools
                        name="tickPricingIcon"
                        class="me-2"
                      />
                      {{ feature }}
                    </li>
                  </ul>
                </div>
                <!-- <div class="d-grid butn-upgrade mt-4">

                                    <button class="btn " style="    color: white;"   *ngIf="!isUserLoggedin" (click)="checkUserIdAndRouteplans()">Subscribe</button>
                                    <button class="btn " style="    color: white;"  *ngIf="isUserLoggedin && (!premium_user_done || premium_user_done == null)" (click)="checkUserIdAndRouteplans()">Upgrade
                                        Plan</button>
                                </div> -->
              </div>
            </div>
          </div>
        </div>

        <!-- </div>
                </div> -->
        <!-- </div> -->
        <!-- End Pricing Update Section -->
        <!-- Pricing Table -->
        <div id="select-content-phone">
          <!-- <select
            style="
              width: 100%;
              height: 40px;
              border-radius: 8px;
              border: 1px solid #e0efed;
              background: #ffffff;
              font-size: 15px;
              font-weight: 500;
              text-align: left;
              outline: none;
              padding: 10px;
            "
            (change)="selectParagraphMobile($event)"
          >
            <option value="1">Free - 0$</option>
            <option value="2">Basic Plan - 5$</option>
            <option value="3">Professional Plan - 12$</option>
          </select> -->
          <div
            style="
              border: 1px solid #e3e3f0;
              border-radius: 10px;
              margin-top: 10px;
              padding: 10px;
              margin-bottom: 10px;
            "
          >
            <div style="display: flex; justify-content: space-between">
              <div>
                <p style="font-size: 14px; font-weight: 500; text-align: left">
                  Write without mistakes
                </p>
              </div>
              <div>
                <app-icons-free-tools
                  name="falsePricingIcon"
                  *ngIf="!showImageWriteWithoutMistakes"
                />

                <app-icons-free-tools
                  name="truePricingIcon"
                  *ngIf="showImageWriteWithoutMistakes"
                />
              </div>
            </div>
            <div
              style="
                display: flex;
                justify-content: space-between;
                margin-top: -10px;
              "
            >
              <div>
                <p style="font-size: 14px; font-weight: 500; text-align: left">
                  See your writing tone
                </p>
              </div>
              <div>
                <app-icons-free-tools
                  name="falsePricingIcon"
                  *ngIf="!showImageSeeYourWritingTone"
                />

                <app-icons-free-tools
                  name="truePricingIcon"
                  *ngIf="showImageSeeYourWritingTone"
                />
              </div>
            </div>
            <div
              style="
                display: flex;
                justify-content: space-between;
                margin-top: -10px;
              "
            >
              <div>
                <p style="font-size: 14px; font-weight: 500; text-align: left">
                  Adjust your writing tone
                </p>
              </div>
              <div>
                <app-icons-free-tools
                  name="falsePricingIcon"
                  *ngIf="!showImageAdjustYourWritingTone"
                />

                <app-icons-free-tools
                  name="truePricingIcon"
                  *ngIf="showImageAdjustYourWritingTone"
                />
              </div>
            </div>
            <div
              style="
                display: flex;
                justify-content: space-between;
                margin-top: -10px;
              "
            >
              <div>
                <p style="font-size: 14px; font-weight: 500; text-align: left">
                  Rewrite full sentences
                </p>
              </div>
              <div>
                <app-icons-free-tools
                  name="falsePricingIcon"
                  *ngIf="!showImageRewriteFullSentences"
                />

                <app-icons-free-tools
                  name="truePricingIcon"
                  *ngIf="showImageRewriteFullSentences"
                />
              </div>
            </div>
            <div
              style="
                display: flex;
                justify-content: space-between;
                margin-top: -10px;
              "
            >
              <div>
                <p style="font-size: 14px; font-weight: 500; text-align: left">
                  Write fluently in English
                </p>
              </div>
              <div>
                <app-icons-free-tools
                  name="falsePricingIcon"
                  *ngIf="!showImageWriteFluentlyInEnglish"
                />

                <app-icons-free-tools
                  name="truePricingIcon"
                  *ngIf="showImageWriteFluentlyInEnglish"
                />
              </div>
            </div>
            <div
              style="
                display: flex;
                justify-content: space-between;
                margin-top: -10px;
              "
            >
              <div>
                <p style="font-size: 14px; font-weight: 500; text-align: left">
                  Use inclusive language
                </p>
              </div>
              <div>
                <app-icons-free-tools
                  name="falsePricingIcon"
                  *ngIf="!showImageUseInclusiveLanguage"
                />

                <app-icons-free-tools
                  name="truePricingIcon"
                  *ngIf="showImageUseInclusiveLanguage"
                />
              </div>
            </div>
            <div
              style="
                display: flex;
                justify-content: space-between;
                margin-top: -10px;
              "
            >
              <div>
                <p style="font-size: 14px; font-weight: 500; text-align: left">
                  Keep your citations consistent
                </p>
              </div>
              <div>
                <app-icons-free-tools
                  name="falsePricingIcon"
                  *ngIf="!showImageKeepYourCitationsConsistent"
                />

                <app-icons-free-tools
                  name="truePricingIcon"
                  *ngIf="showImageKeepYourCitationsConsistent"
                />
              </div>
            </div>
            <div
              style="
                display: flex;
                justify-content: space-between;
                margin-top: -10px;
              "
            >
              <div>
                <p style="font-size: 14px; font-weight: 500; text-align: left">
                  Generate text with AI prompts <br />{{
                    GenerateTextWithAIPrompts
                  }}
                </p>
              </div>
              <div>
                <!-- <img
                  src="../../assets/images/icons/false.svg"
                  alt=""
                  style="height: 18px; width: 18px"
                /> -->
                <app-icons-free-tools name="falsePricingIcon" />
              </div>
            </div>
            <div
              style="
                display: flex;
                justify-content: space-between;
                margin-top: -10px;
              "
            >
              <div>
                <p style="font-size: 14px; font-weight: 500; text-align: left">
                  Generate text with AI prompts <br />{{
                    GenerateTextWithAIPrompts1
                  }}
                </p>
              </div>
              <div>
                <app-icons-free-tools name="falsePricingIcon" />
              </div>
            </div>
            <!--  -->
            <div>
              <h6 style="font-weight: 700">Security features</h6>
            </div>
            <div style="display: flex; justify-content: space-between">
              <div>
                <p style="font-size: 14px; font-weight: 500; text-align: left">
                  Write without mistakes
                </p>
              </div>
              <div>
                <app-icons-free-tools
                  name="falsePricingIcon"
                  *ngIf="!showImageWriteWithoutMistakes"
                />

                <app-icons-free-tools
                  name="truePricingIcon"
                  *ngIf="showImageWriteWithoutMistakes"
                />
              </div>
            </div>
            <div
              style="
                display: flex;
                justify-content: space-between;
                margin-top: -10px;
              "
            >
              <div>
                <p style="font-size: 14px; font-weight: 500; text-align: left">
                  See your writing tone
                </p>
              </div>
              <div>
                <app-icons-free-tools
                  name="falsePricingIcon"
                  *ngIf="!showImageSeeYourWritingTone"
                />

                <app-icons-free-tools
                  name="truePricingIcon"
                  *ngIf="showImageSeeYourWritingTone"
                />
              </div>
            </div>
            <div
              style="
                display: flex;
                justify-content: space-between;
                margin-top: -10px;
              "
            >
              <div>
                <p style="font-size: 14px; font-weight: 500; text-align: left">
                  Adjust your writing tone
                </p>
              </div>
              <div>
                <app-icons-free-tools
                  name="falsePricingIcon"
                  *ngIf="!showImageAdjustYourWritingTone"
                />

                <app-icons-free-tools
                  name="truePricingIcon"
                  *ngIf="showImageAdjustYourWritingTone"
                />
              </div>
            </div>
            <div
              style="
                display: flex;
                justify-content: space-between;
                margin-top: -10px;
              "
            >
              <div>
                <p style="font-size: 14px; font-weight: 500; text-align: left">
                  Rewrite full sentences
                </p>
              </div>
              <div>
                <app-icons-free-tools
                  name="falsePricingIcon"
                  *ngIf="!showImageRewriteFullSentences"
                />

                <app-icons-free-tools
                  name="truePricingIcon"
                  *ngIf="showImageRewriteFullSentences"
                />
              </div>
            </div>
            <div
              style="
                display: flex;
                justify-content: space-between;
                margin-top: -10px;
              "
            >
              <div>
                <p style="font-size: 14px; font-weight: 500; text-align: left">
                  Write fluently in English
                </p>
              </div>
              <div>
                <app-icons-free-tools
                  name="falsePricingIcon"
                  *ngIf="!showImageWriteFluentlyInEnglish"
                />

                <app-icons-free-tools
                  name="truePricingIcon"
                  *ngIf="showImageWriteFluentlyInEnglish"
                />
              </div>
            </div>
            <div
              style="
                display: flex;
                justify-content: space-between;
                margin-top: -10px;
              "
            >
              <div>
                <p style="font-size: 14px; font-weight: 500; text-align: left">
                  Use inclusive language
                </p>
              </div>
              <div>
                <app-icons-free-tools
                  name="falsePricingIcon"
                  *ngIf="!showImageUseInclusiveLanguage"
                />

                <app-icons-free-tools
                  name="truePricingIcon"
                  *ngIf="showImageUseInclusiveLanguage"
                />
              </div>
            </div>
            <div
              style="
                display: flex;
                justify-content: space-between;
                margin-top: -10px;
              "
            >
              <div>
                <p style="font-size: 14px; font-weight: 500; text-align: left">
                  Keep your citations consistent
                </p>
              </div>
              <div>
                <app-icons-free-tools
                  name="falsePricingIcon"
                  *ngIf="!showImageKeepYourCitationsConsistent"
                />

                <app-icons-free-tools
                  name="truePricingIcon"
                  *ngIf="showImageKeepYourCitationsConsistent"
                />
              </div>
            </div>
            <div
              style="
                display: flex;
                justify-content: space-between;
                margin-top: -10px;
              "
            >
              <div>
                <p style="font-size: 14px; font-weight: 500; text-align: left">
                  Catch accidental plagiarism
                </p>
              </div>
              <div>
                <app-icons-free-tools
                  name="falsePricingIcon"
                  *ngIf="!showImageCatchAccidentalPlagiarism"
                />

                <app-icons-free-tools
                  name="truePricingIcon"
                  *ngIf="showImageCatchAccidentalPlagiarism"
                />
              </div>
            </div>
            <div
              style="
                display: flex;
                justify-content: space-between;
                margin-top: -10px;
              "
            >
              <div>
                <p style="font-size: 14px; font-weight: 500; text-align: left">
                  Generate text with AI prompts
                </p>
              </div>
              <div>
                <app-icons-free-tools
                  name="falsePricingIcon"
                  *ngIf="!showImageGenerateTextWithAIPrompts"
                />

                <app-icons-free-tools
                  name="truePricingIcon"
                  *ngIf="showImageGenerateTextWithAIPrompts"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="container py-5" id="select-content">
          <div class="table-responsive">
            <table
              class="table pricing-table"
              style="border-collapse: separate; border-spacing: 0"
            >
              <thead>
                <tr style="background-color: white !important">
                  <th style="border: 0"></th>
                  <th
                    style="
                      border-top-left-radius: 10px;
                      border: 1px solid #e3e3f0;
                    "
                  >
                    <div class="plan-header">
                      <h4>Free User</h4>
                    </div>
                  </th>
                  <th style="border: 1px solid #e3e3f0">
                    <div class="plan-header">
                      <h4>Pro User</h4>
                    </div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style="border-top-left-radius: 8px" class="tBack">
                    Write error-free content
                  </td>
                  <td class="text-center tBack text-danger">
                    <app-icons-free-tools name="truePricingIcon" />
                  </td>
                  <td class="text-center tBack text-danger">
                    <app-icons-free-tools name="truePricingIcon" />
                  </td>
                </tr>
                <tr>
                  <td>Write with fluency</td>
                  <td class="text-center text-success">
                    <app-icons-free-tools name="truePricingIcon" />
                  </td>
                  <td class="text-center text-success">
                    <app-icons-free-tools name="truePricingIcon" />
                  </td>
                </tr>
                <tr>
                  <td class="tBack">Analyze your writing tone</td>
                  <td class="text-center tBack text-success">
                    <app-icons-free-tools name="truePricingIcon" />
                  </td>
                  <td class="text-center tBack text-success">
                    <app-icons-free-tools name="truePricingIcon" />
                  </td>
                </tr>
                <tr>
                  <td style="background-color: #ffffff">
                    Improve your writing tone
                  </td>
                  <td class="text-center text-danger">
                    <app-icons-free-tools name="falsePricingIcon" />
                  </td>
                  <td class="text-center text-success">
                    <app-icons-free-tools name="truePricingIcon" />
                  </td>
                </tr>
                <tr>
                  <td class="tBack">Rewrite full sentences for Clarity</td>
                  <td class="text-center tBack text-danger">
                    <app-icons-free-tools name="falsePricingIcon" />
                  </td>
                  <td class="text-center tBack text-success">
                    <app-icons-free-tools name="truePricingIcon" />
                  </td>
                </tr>
                <tr>
                  <td class="">Extensive Sentiment Analysis</td>
                  <td class="text-center text-danger">
                    <app-icons-free-tools name="falsePricingIcon" />
                  </td>
                  <td class="text-center text-success">
                    <app-icons-free-tools name="truePricingIcon" />
                  </td>
                </tr>
                <tr>
                  <td class="tBack">Refine your writing style and syntax</td>
                  <td class="text-center tBack text-danger">
                    <app-icons-free-tools name="falsePricingIcon" />
                  </td>
                  <td class="text-center tBack text-success">
                    <app-icons-free-tools name="truePricingIcon" />
                  </td>
                </tr>
                <tr>
                  <td>Access to Plagiarism Detection</td>
                  <td class="text-center bld">Limited</td>
                  <td class="text-center bld">Unlimited</td>
                </tr>
                <tr>
                  <td class="tBack">Access to Text Summarizer</td>
                  <td class="text-center bld tBack">Limited</td>
                  <td class="text-center bld tBack">Unlimited</td>
                </tr>
                <tr>
                  <td>Access to Paraphraser</td>
                  <td class="text-center bld">Limited</td>
                  <td class="text-center bld">Unlimited</td>
                </tr>
                <tr>
                  <td class="tBack">Insightful Reports</td>
                  <td class="text-center text-success tBack">
                    <app-icons-free-tools name="falsePricingIcon" />
                  </td>
                  <td class="text-center text-success tBack">
                    <app-icons-free-tools name="truePricingIcon" />
                  </td>
                </tr>

                <tr>
                  <td style="border-bottom-left-radius: 8px" class="">
                    AI Assistant and AI Tools
                  </td>
                  <td class="text-center bld">100 prompts/month</td>
                  <td
                    class="text-center bld"
                    style="border-bottom-right-radius: 8px"
                  >
                    2000 prompts/ month
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!--  -->
    <div class="container mt-5 qustion" id="home-faqs">
      <div
        class="justify-content-center"
        id="row_faqs"
        style="margin-bottom: 20px"
      >
        <div class="faqs text-center">
          <!-- <h3 class="text-center freegrammarcheckText"
                        style="font-size: 18px;font-weight: 700;letter-spacing: 0.21em;text-align: center;">FAQ</h3> -->
          <h1 class="text-center headFont" style="margin-top: -15px">
            Frequently asked questions
          </h1>
          <p class="text mb-5 text headFontP">
            Learn more about platform by user questions
          </p>
        </div>

        <div class="v-pills-tab-list">
          <div class="" id="row_faqs">
            <div
              class="nav flex-column nav-pills"
              id="v-pills-tab"
              role="tablist"
              aria-orientation="vertical"
            >
              <div
                class="container container-grid"
                style="width: min(100% - 40px, 768px)"
              >
                <div
                  class="nav flex-column nav-pills"
                  id="v-pills-tab"
                  role="tablist"
                  aria-orientation="vertical"
                >
                  <a
                    class="nav-link nav-pills"
                    style="
                      border: 1px solid #eaeaea;
                      padding: 10px 14px;
                      background-color: #f3f8fc;
                      border-radius: 10px;
                    "
                    [ngClass]="{ active: activeTab === 'q5' }"
                    (click)="toggleTab('q5')"
                    id="v-pills-first-tab"
                    aria-controls="q5"
                    aria-expanded="false"
                    class="mb-0 collapsed"
                  >
                    <div class="nav-linkFAQ">
                      <h3
                        class="card-header ms-3"
                        [class.closed]="activeTab !== 'q5'"
                      >
                        How to Check Grammar Online?
                      </h3>
                      <app-icons-free-tools
                        name="plusIcon"
                        *ngIf="activeTab !== 'q5'"
                      />
                      <app-icons-free-tools
                        name="minusIcon"
                        *ngIf="activeTab === 'q5'"
                      />
                    </div>

                    <div
                      aria-labelledby="q5"
                      class="collapse"
                      [ngClass]="{ show: activeTab === 'q5' }"
                      id="q5"
                      role="tabpanel"
                      data-parent="#v-pills-tab-list"
                    >
                      <div class="card-body faqPar ms-3 me-3">
                        It is simple: copy and paste your text into the online
                        editor to check grammar. All grammar mistakes will be
                        displayed in the output section. You can fix the
                        highlighted errors as per your preference.
                      </div>
                    </div>
                  </a>
                </div>
                <div
                  class="nav flex-column nav-pills"
                  id="v-pills-tab"
                  role="tablist"
                  aria-orientation="vertical"
                >
                  <a
                    class="nav-link nav-pills"
                    style="
                      border: 1px solid #eaeaea;

                      padding: 10px 14px;
                      background-color: #f3f8fc;
                      border-radius: 10px;
                    "
                    [ngClass]="{ active: activeTab === 'q15' }"
                    (click)="toggleTab('q15')"
                    id="v-pills-2nd-tab"
                    aria-controls="q15"
                    aria-expanded="false"
                    class="mb-0 collapsed"
                  >
                    <div class="nav-linkFAQ">
                      <h3
                        class="card-header ms-3"
                        [class.closed]="activeTab !== 'q15'"
                      >
                        Is This Writing Checker Useful for Non-Native English
                        Speakers?
                      </h3>
                      <app-icons-free-tools
                        name="plusIcon"
                        *ngIf="activeTab !== 'q15'"
                      />
                      <app-icons-free-tools
                        name="minusIcon"
                        *ngIf="activeTab === 'q15'"
                      />
                    </div>

                    <div
                      aria-labelledby="q15"
                      class="collapse"
                      [ngClass]="{ show: activeTab === 'q15' }"
                      id="q15"
                      role="tabpanel"
                      data-parent="#v-pills-tab-list"
                    >
                      <div class="card-body faqPar ms-3 me-3">
                        Yes, our writing checker is beneficial for non-native
                        English speakers. It provides valuable grammar
                        correction help in spotting and correcting grammatical
                        errors. It also offers recommendations for improving
                        clarity, coherence, and language proficiency.
                      </div>
                    </div>
                  </a>
                </div>
                <div
                  class="nav flex-column nav-pills"
                  id="v-pills-tab"
                  role="tablist"
                  aria-orientation="vertical"
                >
                  <a
                    class="nav-link nav-pills"
                    style="
                      border: 1px solid #eaeaea;

                      padding: 10px 14px;
                      background-color: #f3f8fc;
                      border-radius: 10px;
                    "
                    [ngClass]="{ active: activeTab === 'q17' }"
                    (click)="toggleTab('q17')"
                    id="v-pills-3rd-tab"
                    aria-controls="q17"
                    aria-expanded="false"
                    class="mb-0 collapsed"
                  >
                    <div class="nav-linkFAQ">
                      <h3
                        class="card-header ms-3"
                        [class.closed]="activeTab !== 'q17'"
                      >
                        What Other Free Tools Does GrammarIn Offer?
                      </h3>
                      <app-icons-free-tools
                        name="plusIcon"
                        *ngIf="activeTab !== 'q17'"
                      />
                      <app-icons-free-tools
                        name="minusIcon"
                        *ngIf="activeTab === 'q17'"
                      />
                    </div>

                    <div
                      aria-labelledby="q17"
                      class="collapse"
                      [ngClass]="{ show: activeTab === 'q17' }"
                      id="q17"
                      role="tabpanel"
                      data-parent="#v-pills-tab-list"
                    >
                      <div class="card-body faqPar ms-3 me-3">
                        Besides a grammar checker, GrammarIn also offers a free
                        plagiarism checker. It lets you identify whether your
                        text is original or contains duplicate content.
                      </div>
                    </div>
                  </a>
                </div>

                <div
                  class="nav flex-column nav-pills"
                  id="v-pills-tab"
                  role="tablist"
                  aria-orientation="vertical"
                >
                  <a
                    class="nav-link nav-pills"
                    style="
                      border: 1px solid #eaeaea;

                      padding: 10px 14px;
                      background-color: #f3f8fc;
                      border-radius: 10px;
                    "
                    [ngClass]="{ active: activeTab === 'q6' }"
                    (click)="toggleTab('q6')"
                    id="v-pills-4th-tab"
                    aria-controls="q6"
                    aria-expanded="false"
                    class="mb-0 collapsed"
                  >
                    <div class="nav-linkFAQ">
                      <h3
                        class="card-header ms-3"
                        [class.closed]="activeTab !== 'q6'"
                      >
                        How to Correct Grammar Mistakes on My Phone?
                      </h3>
                      <app-icons-free-tools
                        name="plusIcon"
                        *ngIf="activeTab !== 'q6'"
                      />
                      <app-icons-free-tools
                        name="minusIcon"
                        *ngIf="activeTab === 'q6'"
                      />
                    </div>

                    <div
                      aria-labelledby="q6"
                      class="collapse"
                      [ngClass]="{ show: activeTab === 'q6' }"
                      id="q6"
                      role="tabpanel"
                      data-parent="#v-pills-tab-list"
                    >
                      <div class="card-body faqPar ms-3 me-3">
                        Access our AI grammar corrector on the web using your
                        phone's default browser. Paste the text in the given
                        field. It will only take seconds to detect grammar
                        errors.
                      </div>
                    </div>
                  </a>
                </div>

                <div
                  class="nav flex-column nav-pills"
                  id="v-pills-tab"
                  role="tablist"
                  aria-orientation="vertical"
                >
                  <a
                    class="nav-link nav-pills"
                    style="
                      border: 1px solid #eaeaea;

                      padding: 10px 14px;
                      background-color: #f3f8fc;
                      border-radius: 10px;
                    "
                    [ngClass]="{ active: activeTab === 'q7' }"
                    (click)="toggleTab('q7')"
                    id="v-pills-5th-tab"
                    aria-controls="q7"
                    aria-expanded="false"
                    class="mb-0 collapsed"
                  >
                    <div class="nav-linkFAQ">
                      <h3
                        class="card-header ms-3"
                        [class.closed]="activeTab !== 'q7'"
                      >
                        How Can I Ensure that My Writing is Grammatically
                        Correct?
                      </h3>
                      <app-icons-free-tools
                        name="plusIcon"
                        *ngIf="activeTab !== 'q7'"
                      />
                      <app-icons-free-tools
                        name="minusIcon"
                        *ngIf="activeTab === 'q7'"
                      />
                    </div>

                    <div
                      aria-labelledby="q7"
                      class="collapse"
                      [ngClass]="{ show: activeTab === 'q7' }"
                      id="q7"
                      role="tabpanel"
                      data-parent="#v-pills-tab-list"
                    >
                      <div class="card-body faqPar ms-3 me-3">
                        You can ensure your writing is grammatically correct by
                        conducting a grammar check with the GrammarIn writing
                        checker.
                      </div>
                    </div>
                  </a>
                </div>

                <div
                  class="nav flex-column nav-pills"
                  id="v-pills-tab"
                  role="tablist"
                  aria-orientation="vertical"
                >
                  <a
                    class="nav-link nav-pills"
                    style="
                      border: 1px solid #eaeaea;

                      padding: 10px 14px;
                      background-color: #f3f8fc;
                      border-radius: 10px;
                    "
                    [ngClass]="{ active: activeTab === 'q16' }"
                    (click)="toggleTab('q16')"
                    id="v-pills-6th-tab"
                    aria-controls="q16"
                    aria-expanded="false"
                    class="mb-0 collapsed"
                  >
                    <div class="nav-linkFAQ">
                      <h3
                        class="card-header ms-3"
                        [class.closed]="activeTab !== 'q16'"
                      >
                        Is There a Free Tool Like GrammarIn to Check Grammar
                        Mistakes?
                      </h3>
                      <app-icons-free-tools
                        name="plusIcon"
                        *ngIf="activeTab !== 'q16'"
                      />
                      <app-icons-free-tools
                        name="minusIcon"
                        *ngIf="activeTab === 'q16'"
                      />
                    </div>

                    <div
                      aria-labelledby="q16"
                      class="collapse"
                      [ngClass]="{ show: activeTab === 'q16' }"
                      id="q16"
                      role="tabpanel"
                      data-parent="#v-pills-tab-list"
                    >
                      <div class="card-body faqPar ms-3 me-3">
                        Yes! You can use the GrammarIn grammar checker to check
                        grammar mistakes. It is entirely free and works more
                        efficiently than GrammarIn.
                      </div>
                    </div>
                  </a>
                </div>
                <div
                  class="nav flex-column nav-pills"
                  id="v-pills-tab"
                  role="tablist"
                  aria-orientation="vertical"
                >
                  <a
                    class="nav-link nav-pills"
                    style="
                      border: 1px solid #eaeaea;

                      padding: 10px 14px;
                      background-color: #f3f8fc;
                      border-radius: 10px;
                    "
                    [ngClass]="{ active: activeTab === 'q14' }"
                    (click)="toggleTab('q14')"
                    id="v-pills-7th-tab"
                    aria-controls="q14"
                    aria-expanded="false"
                    class="mb-0 collapsed"
                  >
                    <div class="nav-linkFAQ">
                      <h3
                        class="card-header ms-3"
                        [class.closed]="activeTab !== 'q14'"
                      >
                        What Are Some Common Grammar Mistakes?
                      </h3>
                      <app-icons-free-tools
                        name="plusIcon"
                        *ngIf="activeTab !== 'q14'"
                      />
                      <app-icons-free-tools
                        name="minusIcon"
                        *ngIf="activeTab === 'q14'"
                      />
                    </div>

                    <div
                      aria-labelledby="q14"
                      class="collapse"
                      [ngClass]="{ show: activeTab === 'q14' }"
                      id="q14"
                      role="tabpanel"
                      data-parent="#v-pills-tab-list"
                    >
                      <div class="card-body faqPar ms-3 me-3">
                        Some common grammar mistakes include the misuse of
                        tenses, subject-verb agreement errors, incorrect word
                        order, and improper punctuation.
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-footer></app-footer>
